import api from 'utils/api';

const API_BASE_PATH = process.env.REACT_APP_API_URL;

// 투어 회차(departure) 목록 조회
export const getTravelDepartures = async (tourId, status) => {
    try {
        const params = status ? { status } : {};
        const res = await api.get(
            `/buccl_main/api/v1/travel-products/${tourId}/departures/`,
            { params }
        );
        return res.data;
    } catch (err) {
        console.error('getTravelDepartures API 에러:', err);
        return [];
    }
};


//투어 상품 목록 조회
export const getTravelProduct = async (id) => {
    try {
        if(id){
            const res = await api.get(`${API_BASE_PATH}/buccl_main/api/v1/travel-products/${id}`);
            return res.data
        }else{
            const res = await api.get(`/buccl_main/api/v1/travel-products`);
            return res.data
        }
    } catch (err) {
        console.error('getClassProduct API 에러:', err);
        return [];
    }
};

// 투어 상품 페이지네이션 목록 조회 (무한스크롤용)
export const getTravelProductList = async (page = 1) => {
    try {
        const res = await api.get('/buccl_main/api/v1/travel-products/', {
            params: { page },
        });
        return res.data;
    } catch (err) {
        console.error('getTravelProductList API 에러:', err);
        return null;
    }
};

export const getTravelList = async (date) => {
  try {
    const res = await api.get(`/buccl_main/api/v1/travel-products/`, {
      params: date ? { month: date } : {},
    });

    return res.data;

  } catch (err) {
    console.error('getClassProduct API 에러:', err);
    return [];
  }
};

// 내가 개설한 투어 목록 조회
export const getMyTravelProducts = async () => {
    try {
        const res = await api.get('/buccl_main/api/v1/travel-products/my/');
        return res.data;
    } catch (err) {
        console.error('getMyTravelProducts API 에러:', err);
        return [];
    }
};


// 내가 개설한 투어 참가자 목록 조회
export const getMyTravelParticipants = async (id) => {
  try {
      const res = await api.get(`/buccl_main/api/v1/travel-products/${id}/participants/`);
      return res.data;
  } catch (err) {
      console.error('getMyTravelProducts API 에러:', err);
      return [];
  }
};

// 강사 투어 목록 조회
export const getInstructorTours = async () => {
    try {
        const res = await api.get('/buccl_main/api/v1/tours/instructor/');
        return res.data;
    } catch (err) {
        console.error('getInstructorTours API 에러:', err);
        return [];
    }
};

// 내가 참가한 투어 목록 조회
export const getMyTours = async (includePast = false) => {
    try {
        const res = await api.get('/buccl_main/api/v1/tours/student/', {
            params: { include_past: includePast, page_size: 50 },
        });
        return res.data?.results || [];
    } catch (err) {
        console.error('getMyTours API 에러:', err);
        return [];
    }
};

// 투어 정보 수정 (PATCH)
export const updateTravelProduct = async (id, body) => {
    try {
        const res = await api.patch(`/buccl_main/api/v1/travel-products/${id}/update/`, body);
        return res.data;
    } catch (err) {
        console.error('updateTravelProduct API 에러:', err);
        throw err;
    }
};


//승인 대기 중인 투어 목록
export const getPendingTravelDetail = async (id) => {
  try {
    const res = await api.get(`${API_BASE_PATH}/buccl_main/api/v1/travel-products-approvals/${id}`);
    return res.data
    
  } catch (err) {
      console.error('getClassProduct API 에러:', err);
      return [];
  }
};

// ── 투어 찜하기 ─────────────────────────────

// 투어 찜하기 (처음 201, 이미 찜했으면 200)
export const likeTravelProduct = async (id) => {
    const res = await api.post(`/buccl_main/api/v1/travel-products/${id}/like/`);
    return res.data;
};

// 투어 찜 해제 (항상 204)
export const unlikeTravelProduct = async (id) => {
    await api.delete(`/buccl_main/api/v1/travel-products/${id}/like/`);
};

// 내 찜 투어 목록 (최근 찜 순, 공개 투어만)
export const getMyLikedTravelProducts = async (page = 1) => {
    const res = await api.get('/buccl_main/api/v1/travel-products/likes/me/', {
        params: { page },
    });
    return res.data;
};

// ids 응답이 배열 / { ids } / { results } 중 어떤 형태여도 숫자 ID 배열로 맞춘다.
export const normalizeLikedTravelIds = (data) => {
    const list = Array.isArray(data) ? data : data?.ids ?? data?.results ?? [];
    return list
        .map((v) => (typeof v === 'object' && v !== null ? v.id ?? v.travel_product_id : v))
        .map(Number)
        .filter((v) => !Number.isNaN(v));
};

// 내 찜 투어 ID 목록 (하트 표시용)
export const getMyLikedTravelProductIds = async () => {
    const res = await api.get('/buccl_main/api/v1/travel-products/likes/me/ids/');
    return normalizeLikedTravelIds(res.data);
};

// 관리자용 투어별 찜 수 (찜 많은 순, 페이지)
export const getAdminTravelProductLikes = async (page = 1) => {
    const res = await api.get('/buccl_main/api/v1/admin/travel-products/likes/', {
        params: { page },
    });
    return res.data;
};
